import $ from 'jquery';

$(document).ready(function() {
  this.searchInput = '[data-search-input]';
  this.searchInputClear = '[data-search-clear]';

  $(this.searchInputClear).on('click', () => {
    console.log('clear', $(this.searchInput));
    $(this.searchInput).val('');
  });
});
